import React from 'react';
import { useT } from '../../../../i18n';

const SEATED = [
  { initial: 'R', color: '#9E5462' },
  { initial: 'E', color: '#9E5462' },
  { initial: 'A', color: '#2F7D5B' },
  { initial: 'M', color: '#C98A1E' },
  { initial: 'T', color: '#3F5573' },
  { initial: 'S', color: '#2F7D5B' },
  { initial: 'N', color: '#CFA0A9' },
];
const EMPTY_SEAT = 1; // place libre où Julie est déposée

// Place (en px) d'une chaise autour de la table ronde.
function seatPos(i: number) {
  const a = (i * Math.PI) / 4;
  return { left: Math.round(215 + 52 * Math.cos(a) - 11), top: Math.round(110 + 52 * Math.sin(a) - 11) };
}

// Plan de table : on glisse Julie depuis « À placer » jusqu'à sa chaise.
const SeatingVisual: React.FC = () => {
  const t = useT();
  let k = 0;
  return (
    <div className="mk-fv-box mk-fv-seating">
      <span className="mk-fv-k mk-fv-seating-title">{t('Plan de table')}</span>
      <span className="mk-fv-seating-count">
        <span className="mk-fv-sc1">{t('Témoins')} · 7 / 8</span>
        <span className="mk-fv-sc2">{t('Témoins')} · 8 / 8 ✓</span>
      </span>
      <span className="mk-fv-seating-label">{t('À placer')}</span>
      <span className="mk-fv-slot" />
      <span className="mk-fv-chip mk-fv-drag" style={{ top: 64 }}>
        <i style={{ background: '#9E5462' }} />
        Julie M.
      </span>
      <span className="mk-fv-chip" style={{ top: 96 }}>
        <i style={{ background: '#3F5573' }} />
        Paul R.
      </span>
      <span className="mk-fv-chip" style={{ top: 128 }}>
        <i style={{ background: '#C98A1E' }} />
        Inès B.
      </span>
      <span className="mk-fv-table">T1</span>
      {Array.from({ length: 8 }, (_, i) => {
        const pos = seatPos(i);
        if (i === EMPTY_SEAT) {
          return (
            <React.Fragment key={i}>
              <span className="mk-fv-seat is-empty" style={pos} />
              <span className="mk-fv-seat mk-fv-seat-in" style={{ ...pos, background: '#9E5462' }}>
                J
              </span>
            </React.Fragment>
          );
        }
        const s = SEATED[k++];
        return (
          <span key={i} className="mk-fv-seat" style={{ ...pos, background: s.color }}>
            {s.initial}
          </span>
        );
      })}
      <svg className="mk-fv-cursor" width="18" height="18" viewBox="0 0 24 24">
        <path d="M4 2 L4 20 L9 15 L13 22 L16 20.5 L12 13.5 L19 13.5 Z" fill="#1F1B19" stroke="#fff" strokeWidth="1.5" strokeLinejoin="round" />
      </svg>
    </div>
  );
};

export default SeatingVisual;
